import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import qs from "qs";
import {
  editStockCategory,
  getStockCategoryList,
  saveStockCategory,
  removeStockCategory,
  getStockCategory,
  sortOrderStockCategory,
  sortOrderStockSubCategory,
} from "../api";
import { errorMessage, successMessage } from "../../../utils/helper";

const stockCategoryKeys = {
  all: ["stock-categories"],
  list: () => [...stockCategoryKeys.all, "stock-categorylist"],
  categorylist: (filters) => [...stockCategoryKeys.list(), { filters }],
  detail: (id) => [...stockCategoryKeys.categorylist(), id],
};
export const useStockCategoryQueries = ({
  categorylist = false,
  detailsIds,
  debouncedText,
  resetDeleteInfo,
  onSelectItem,
} = {}) => {
  const queryClient = useQueryClient();
  let params = {};
  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }

  const query = qs.stringify(params, {
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  });
  // list query
  const listQuery = useQuery({
    queryKey: stockCategoryKeys.categorylist(query),
    queryFn: () => getStockCategoryList(query),
  });

  //create category
  const createCategory = useMutation({
    mutationFn: saveStockCategory,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: stockCategoryKeys.list(),
      });
      successMessage(_.message);
      if (variables.payload.parent_stock_category_id)
        onSelectItem(variables?.selectedData);
      else onSelectItem(_.data);
      variables.handleClose();
    },
  });

  //update category
  const updateCategory = useMutation({
    mutationFn: editStockCategory,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: stockCategoryKeys.list(),
      });
      successMessage(_.message);
      variables.handleClose();
    },
  });

  //delete category
  const deleteCategory = useMutation({
    mutationFn: removeStockCategory,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (res) => {
      if (res.success) {
        queryClient.invalidateQueries({
          queryKey: stockCategoryKeys.list(),
        });
        successMessage(res.message);
        resetDeleteInfo();
      } else if (res.success === false) {
        errorMessage(res.message);
      }
    },
  });

  //category details
  const categoryDetails = useQuery({
    queryKey: stockCategoryKeys.detail(detailsIds),
    queryFn: () => getStockCategory(detailsIds),
    enabled: detailsIds > 0,
  });
  //sort order category
  const sortOrderCategoryList = useMutation({
    mutationFn: sortOrderStockCategory,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (_, variables) => {
      successMessage(_.message);
    },
  });
  const sortOrderSubCategoryList = useMutation({
    mutationFn: sortOrderStockSubCategory,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (_, variables) => {
      successMessage(_.message);
    },
  });

  return {
    listQuery,
    updateCategory,
    createCategory,
    deleteCategory,
    categoryDetails,
    sortOrderCategoryList,
    sortOrderSubCategoryList,
  };
};
